import React from 'react';
import { Chip } from '@mui/material';
import { useGetProductImages } from '@hooks/useProductImages';
import { useGetDealSummary } from '@hooks/useGetDealSummary';
import config from '@configFile';
import { getProductLink } from '@utils/index';

const AddShortCut = ({
  ASIN,
  setPostText,
  postText
}: {
  ASIN: string;
  setPostText: (value: string) => void;
  postText: string;
}) => {
  const { data: dealSummaryData } = useGetDealSummary(ASIN);
  const { data: productImageData } = useGetProductImages(ASIN);
  const productImages = productImageData || [];
  const title = dealSummaryData?.title || ASIN;
  const image =
    dealSummaryData?.image100Url || productImages?.[0]?.image || null;
  const link = getProductLink(ASIN, config.AFFILIATE_TAGS.HAUL);

  return (
    <>
      {productImages.map((productImage) => (
        <Chip
          sx={{
            marginRight: '6px'
          }}
          key={productImage.image}
          avatar={
            <img
              src={productImage.image}
              alt={productImage.caption}
              style={{ width: 24, height: 24 }}
            />
          }
          label={`Add Image: ${productImage.caption?.substring(0, 20)}`}
          onClick={() =>
            setPostText(
              `${postText} <ProductImage ASIN="${ASIN}" image="${productImage.image}" />\n\n`
            )
          }
          disabled={postText.includes(
            `<ProductImage ASIN="${ASIN}" image="${productImage.image}" />`
          )}
        />
      ))}
      <Chip
        key="title"
        avatar={
          image ? (
            <img src={image} alt={title} style={{ width: 24, height: 24 }} />
          ) : null
        }
        label={`Add title: ${title?.substring(0, 20)}`}
        onClick={() => setPostText(`${postText} [${title}](${link}) `)}
        disabled={postText.includes(`[${title}](${link})`)}
        sx={{
          marginRight: '6px'
        }}
      />
      <Chip
        key="price"
        avatar={
          image ? (
            <img src={image} alt={title} style={{ width: 24, height: 24 }} />
          ) : null
        }
        label={`Add Price: ${title?.substring(0, 20)}`}
        onClick={() => setPostText(`${postText} <Price ASIN="${ASIN}" />`)}
        disabled={postText.includes(`<Price ASIN="${ASIN}" />`)}
        sx={{
          marginRight: '6px'
        }}
      />
    </>
  );
};

export default AddShortCut;
